import React from 'react';
import classNames from 'classnames';

import styles from './Dropdown.module.scss';

const MenuDivider: React.FC<React.HTMLAttributes<HTMLDivElement>> = props => {
  const { className, ...restProps } = props;
  return <div className={classNames(styles.divider, className)} {...restProps} />;
  // return <li className={styles.divider} />;
};

export default MenuDivider;
